// extracted by mini-css-extract-plugin
export default {"container":"rC-z","modal":"sC-z","dimensions":"tC-z","brandName":"uC-z","productName":"vC-z","labelValue":"wC-z","recipientEmail":"xC-z","recommendedFit":"yC-z","hiddenField":"zC-z"};